export const colors = {
  black: '#000000',
  darkGrey: '#21252b',
  grey: '#5a5a5a',
  lightGrey: '#eee',
  white: '#ffffff',
  red: '#f44747',
  darkYellow: '#b89500',
  yellow: '#e2c08d',
  darkGreen: '#008000',
  green: '#0dbc79',
  turqoise: '#4EC9B0',
  darkBlue: '#000080',
  blue: '#0097fb',
  lightBlue: '#9CDCFE',
  purple: '#6c6cc4',
  pink: '#b267e6'
}
